export const resources = {
    cart: 'cart',
    rdssCart: 'rd-api/cart',
    updateCart: 'checkout/ajaxAmount',
    products: 'products/index/id',
    productSearch: 'rd-api/products',
    translations: 'rd-api/translations',
    cartLineItem: 'cart/item',
    wishlist: 'note/ajaxAdd/ordernumber',
    csrf: 'csrftoken',
    loyaltyMember: 'rd-api/loyalty-member',
    loyaltyProgram: 'rd-api/loyalty-program',
    petProfiles: 'rd-api/pet-profiles',
    petTypes: 'rd-api/pet-types',
    loyaltyVoucher: 'rd-api/loyalty-voucher',
    loyaltyPoints: 'rd-api/loyalty-order-points',
    loyaltyMemberPoints: 'rd-api/loyalty-member-points',
    citrusad: 'rd-api/citrusadsbanner',
};
//# sourceMappingURL=resources.js.map